import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_WEB_FEEDBACK__send_us_feedback]: 'Send us Feedback',
  [StringId.DV_WEB_FEEDBACK_feedback]: 'Feedback',
  [StringId.DV_WEB_FEEDBACK_select_related_device]: 'Which device is your feedback for?',
  [StringId.DV_WEB_FEEDBACK_select_option_dropdown_menu]: 'Please select an option from the dropdown menu',
  [StringId.DV_WEB_FEEDBACK_dropdown_prompt]: 'Please select a device...',
  [StringId.DV_WEB_FEEDBACK_submit_button]: 'Continue',
  [StringId.DV_WEB_FEEDBACK_no_device_website]: 'No device, it\'s about the website',
  [StringId.DV_WEB_SETTINGS_HEAD_YOUR_DEVICES]: 'Your Devices',
}